import React from 'react'
import { Card, LazyImage } from '@offerzen/pinata-shame'

import { JobListEmptyState } from '../constants'

import styles from './styles'

const content = {
  [JobListEmptyState.MATCH]: {
    title: "There aren't jobs that match your profile",
    message:
      "Don't worry, this doesn't mean there aren't jobs available on OfferZen for you. Not all companies list their jobs here. Check back again later.",
  },
  [JobListEmptyState.SEARCH]: {
    title: "There aren't any jobs that match your search",
    message: 'Try updating your search criteria.',
    imageLoader: () => import('@/assets/cat-with-magnifying-glass.svg'),
  },
}

const EmptyListCard = ({ type }) => {
  const { title, message, imageLoader } = content[type]

  return (
    <Card className={styles.wrapper}>
      {typeof imageLoader === 'function' && <LazyImage loader={imageLoader} alt="" width={210} className={styles.image} />}
      <h4 className={styles.heading}>{title}</h4>
      <p className={styles.text}>{message}</p>
    </Card>
  )
}

export default EmptyListCard
